import React, { useEffect, useState } from 'react';
import './_REPersonal.scss';
import { useTranslation } from 'react-i18next';
import UiIntegrater from '../../historyRecord/littleUIComponent/UiIntegrater';
import REDropdown from '../REDropdown/REDropdown';
// import DateCalander from '../../historyRecord/littleUIComponent/DateCalander';
import DatePicker from 'react-datepicker';
import ApiGo from '../../../../actions/ApiGo';
import { useDispatch } from 'react-redux';
import { ADD_RESIDENTS_ARRAY } from '../../../../stores/reducer_residentsArray';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../../../stores/reducer_add';
import PopConfirm from '../../../popUp/PopConfirm';
import { ADD_BEDS_ARRAY } from '../../../../stores/reducer_beds';
import ConfigHandler from '../../../../actions/ConfigHandler';

const soap_patient = {
  BIRTHDATE: '',
  PATIENTNAME: '',
  PATNO: '',
  SEX: '',
  WARDBEDNO: '',
};
const REPersonal = (props) => {
  const p = props.data;
  const is_Kmuh = ConfigHandler.isKmuh;
  // i18n翻譯
  const { t } = useTranslation();
  const defauleGender = p?.gender?.toLowerCase() === 'female' || p?.gender === '女'
    ? t('GLOBAL.FEMALE')
    : t('GLOBAL.MALE');
  // ##### STEP1：製作各欄位提取方式 #####
  // 各欄位 input value
  const [med_record_num, setMed_record_num] = useState(p?.med_record_num ?? ''); // residents.first_name? med_record_num
  const [memo, setMemo] = useState(p?.special_conditions ?? ''); // residents.special_conditions
  const [first_name, setFirst_name] = useState(p?.first_name ?? ''); // residents.height
  const [last_name, setLast_name] = useState(p?.last_name ?? ''); // residents.height
  const [height_cm, setHeight_cm] = useState(p?.height ?? 0); // residents.height
  const [weight_kg, setWeight_kg] = useState(p?.weight ?? 0); // residents.weight
  const [birth_date, setBirth_date] = useState(() => {
    if (p && p.birthday) {
      const parsedDate = new Date(p.birthday);
      return isNaN(parsedDate.getTime()) ? null : parsedDate;
    }
    return null;
  }); // residents.birthday
  // const [birth_date, setBirth_date ] = useState(null) // residents.birthday
  // 血型 ABO 和 RH 是並存的，所以標示為 "A_+", "B_-", "o_+"... ; 所以要 bloodtype.split("_")=>[0]為ABO, [1]為RH
  const [blood_type, setBlood_type] = useState(
    p !== undefined && p.blood_type !== undefined && p.blood_type !== null
      ? p.blood_type.split('_')[0]
      : ''
  );
  const [blood_type_RH, setBlood_type_RH] = useState(
    p !== undefined && p.blood_type !== undefined && p.blood_type !== null
      ? p.blood_type.split('_')[1]
      : ''
  );
  const [address, setAddress] = useState(p?.address ?? ''); // residents.address
  const [emerg_name, setEmerg_name] = useState(p?.emergency_contact ?? ''); // residents.emergency_contact
  const [emerg_home_phone, setEmerg_home_phone] = useState(p?.home_phone ?? ''); // residents.home_phone
  const [emerg_cell_phone, setEmerg_cell_phone] = useState(p?.cell_phone ?? ''); // residents.cell_phone
  // const [room_name, setRoom_name] = useState(p !== undefined ? p.room_name : ''); // residents.room_name 房號
  // 選單內容--性別
  //const [gender , setGender] = useState(p !== undefined ? p.gender : 0) // residents.gender 0:女, 1:男
  const [gender, setGender] = useState(defauleGender);
  const [genderSwitch, setGenderSwitch] = useState(false); // 設定開、關
  function SwitchFunction() {
    setGenderSwitch(!genderSwitch);
  } // 開、關的按鈕
  // 選單內容--生日日期
  const [CalSwitch, setCalSwitch] = useState(false);
  function toggleCal() {
    setCalSwitch(!CalSwitch);
  } // 開、關的按鈕

  // 處理日期在這--------------------------
  const [dayMonth, setDayMonth] = useState('');

  useEffect(() => {
    if (birth_date === null) return;
    setDayMonth(`${birth_date.getFullYear()}/${birth_date.getMonth() + 1}/${birth_date.getDate()}`);
  }, [t, birth_date, blood_type]);

  const handleChange = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    setBirth_date(utcDate);
    setDayMonth(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`);
    setCalSwitch(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setCalSwitch(!CalSwitch);
  };
  // 處理 kmtth soap 搜尋
  const [focus, setFocus] = useState(false);
  const [soapResult, setSoapResult] = useState(soap_patient);
  const [soapPatientBool, setSoapPatientBool] = useState(false);

  function handleSoapSearch(value) {
    setMed_record_num(value);
    if (is_Kmuh) {
      setFocus(true);
      if (value.length <= 7) {
        return;
      }
      ApiGo.getPatientData_chartNo('IPD', value)
        .then((res) => {
          setSoapResult(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  function searchKeyPress(key) {
    setFocus(false);
    if (key === 'Enter') {
      setSoapPatientBool(true);
    }
  }
  function handleSoapClick() {
    setFocus(false);
    setSoapPatientBool(true);
  }
  useEffect(() => {
    if (!soapPatientBool) {
      return;
    }
    setFirst_name(soapResult.WARDBEDNO);
    setLast_name(soapResult.PATIENTNAME);
    setBirth_date(new Date(Date.parse(soapResult.BIRTHDATE)));
    setGender(soapResult.SEX === 'F' ? t('GLOBAL.FEMALE') : t('GLOBAL.MALE'));
  }, [soapPatientBool]);
  // ----------- redux ---------------
  const dispatch = useDispatch();
  // --------------- update redux ---------------
  const [UpdateRedux, setUpdateRedux] = useState(false);
  useEffect(() => {
    if (UpdateRedux) {
      ApiGo.getBed().then((res) => {
        ApiGo.getResidents().then((res) => {
          dispatch(ADD_RESIDENTS_ARRAY(res));
        });
        dispatch(ADD_BEDS_ARRAY(res.beds) || []);
      });
      setUpdateRedux(false);
    }
  }, [UpdateRedux]);

  // ##### STEP2：API_PUT 設定更新[功能]#####
  function API_PUT() {
    setUpdateRedux(false);
    // 整理要put的資料
    const JSONdataPost = {
      first_name: first_name || '',
      last_name: last_name === '' ? p.last_name : last_name,
      // room_name: room_name || '', // 房號
      med_record_num: med_record_num || 0,
      special_conditions: memo || '',
      height: height_cm || 0,
      weight: weight_kg || 60,
      gender: gender || 0,
      birthday: dayMonth || 0,
      blood_type: blood_type + '_' + blood_type_RH || '',
      address: address || '',
      emergency_contact: emerg_name || '',
      home_phone: emerg_home_phone || '',
      cell_phone: emerg_cell_phone || '',
      created_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
      updated_at: new Date().Format('yyyy-MM-ddThh:mm:ss.SZ'),
    };
    ApiGo.putResidents_personal_info(JSONdataPost, props.data.id)
      .then((res) => {
        dispatch(ADD_RESPONSE({ status: 200, statusText: 'success', type: 'update_resident' }));
        setUpdateRedux(true);
        // props.setRefresh(!props.refresh);
        props.hide();
      })
      .catch((err) => {
        dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: 'create_resident' }));
        return err.response;
      })
      .then((res) => {
        dispatch(ADD_RESPONSE_JSON(res));
      });
  }
  // ##### STEP3：製作確認視窗 有房號版本#####
  // let arr = [
  //   [
  //     [t('GLOBAL.ROOM_NO'), room_name],
  //     [t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER'), med_record_num],
  //   ],
  //   [
  //     [t('GLOBAL.BED_NO'), first_name],
  //     [t('GLOBAL.NAME'), last_name],
  //   ],
  //   [
  //     [t('GLOBAL.HEIGHT'), height_cm],
  //     [t('GLOBAL.WEIGHT'), weight_kg],
  //   ],
  //   [
  //     [t('GLOBAL.GENDER'), gender],
  //     [t('GLOBAL.BIRTHDAY'), dayMonth],
  //   ],
  //   [[t('GLOBAL.BLOOD_TYPE'), blood_type], []],
  //   [[t('GLOBAL.ADDRESS'), address], []],
  //   [[t('GLOBAL.NAME'), emerg_name], []],
  //   [
  //     [t('GLOBAL.HOME_PHONE'), emerg_home_phone],
  //     [t('GLOBAL.CELLPHOME_NUMBER'), emerg_cell_phone],
  //   ],
  //   [[t('RESIDENTS_SETTING.MEMO'), memo]],
  // ];

  // ##### STEP3：製作確認視窗 沒有房號版本#####
  let arr = [
    [
      [t('GLOBAL.BED_NO'), first_name],
      [t('GLOBAL.NAME'), last_name],
    ],
    [
      [t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER'), med_record_num],
      [t('GLOBAL.HEIGHT'), height_cm],
    ],
    [
      [t('GLOBAL.WEIGHT'), weight_kg],
      [t('GLOBAL.GENDER'), gender],
    ],
    [
      [t('GLOBAL.BIRTHDAY'), dayMonth],
      [t('GLOBAL.BLOOD_TYPE'), blood_type],
    ],
    [
      [t('GLOBAL.ADDRESS'), address],
      [t('GLOBAL.NAME'), emerg_name],
    ],
    [
      [t('GLOBAL.HOME_PHONE'), emerg_home_phone],
      [t('GLOBAL.CELLPHOME_NUMBER'), emerg_cell_phone],
    ],
    [[t('RESIDENTS_SETTING.MEMO'), memo]],
  ];
  let txt = (
    <>
      <div className="w-50 fx-d-r fx-fsc mar-10">{t('RESIDENTS_SETTING.AUTO.PLEASE_CHECK_FOLLOWING_DATA_SETTINGS')}:</div>
      {arr.map((res, index) => {
        return (
          <div className="w-100 fx-d-r" key={index} style={{ overflow: "hidden" }}>
            {res === undefined
              ? null
              : res.map((r) => {
                return (
                  <div key={r} className={`${index === arr.length - 1 ? 'w-100 mb' : 'w-50'} fx-d-r fx-fsc`} style={{ minWidth: 0, overflow: "hidden" }}>
                    <div className="w-40 fx-fsc" style={{ flexShrink: 0 }}>{r[0]}</div>
                    <div className="w-60 fx-fsc" style={{ display: "block", overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis", minWidth: 0 }}>{r[1]}</div>
                  </div>
                );
              })}
          </div>
        );
      })}
    </>
  );
  // pop 確認視窗
  const [pop, setPop] = useState({
    open: false,
    content: '',
    parameter: [],
  });
  function togglePop() {
    setPop({
      open: false,
      content: '',
      parameter: [],
    });
  }
  // pop 確認視窗

  return (
    <>
      {/* 資料過濾區塊 */}
      <UiIntegrater OnOff_switch={[false, false, false, true, true]} date={birth_date} setReturnDate={() => { }} name={p !== undefined ? p.last_name : ''} bed={p !== undefined ? p.first_name : ''} />
      {/* TEMPLATE */}
      <div className="wrap-personal w-100 h-80" style={{ display: 'flex' }}>
        {pop.open ? <PopConfirm title={t('RESIDENTS_SETTING.RESIDENT_SETTING')} content={pop.content} hide={togglePop} callBack={API_PUT} parameter={pop.parameter} /> : null}
        <div className="h-100 l-s-container">
          {/* 房號欄位 */}
          {/* <div className="h-10 flied">
            <div className="fx-ccc w-50 h-75 title_typeA">{t('GLOBAL.ROOM_NO')}</div>
            <div className="w-50 h-75 content_input pad-5 t">
              <input
                type="text"
                value={room_name}
                onChange={(e) => {
                  const trimmedValue = e.target.value.trim();
                  setRoom_name(trimmedValue);
                }}
              />
            </div>
          </div> */}
          <div className="h-10 flied">
            <div className="fx-ccc w-50 h-75 title_typeA">{t('RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER')}</div>
            <div className="w-50 h-75 content_input pad-5 t">
              <input
                type="text"
                value={med_record_num}
                onChange={(e) => {
                  handleSoapSearch(e.target.value);
                }}
                onKeyDown={(e) => {
                  is_Kmuh && searchKeyPress(e.key);
                }}
              />
              {is_Kmuh && focus && (
                <div className="pos-a w-10 fx-ccc pad-5 r">
                  {soapResult.PATNO === '' ? (
                    <div className="selecBox w-100 fx-ccc">請輸入完整病歷號碼</div>
                  ) : (
                    <div className="selecBox w-100 fx-ccc" onClick={handleSoapClick}>
                      {soapResult.WARDBEDNO}-{soapResult.PATIENTNAME}
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-50 h-75 title_typeA">{t('RESIDENTS_SETTING.MEMO')}</div>
            <div className="fx-ccc w-50 h-75"></div>
          </div>
          <div className="h-60 content_input_b">
            <textarea
              value={memo ?? ""}
              onChange={(e) => {
                setMemo(e.target.value);
              }}
            />
          </div>
          <div className="h-10 flied"></div>
        </div>
        <div className="h-100 r-s-container">
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeB">{t('RESIDENTS_SETTING.ADVANCED_PROFILE')}</div>
          </div>
          <div className="h-10 flied ">
            {/* 床號 */}
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.BED_NO')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={first_name}
                onChange={(e) => {
                  setFirst_name(e.target.value);
                }}
              />
            </div>
            {/* 姓名 */}
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.NAME')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={last_name}
                maxLength="20"
                onChange={(e) => {
                  // const value = e.target.value.replace(/[^\u4e00-\u9fa5\u3105-\u3129\u02CA\u02C7\u02CB\u02D9\A-Za-z]+/g,"")
                  // setLast_name(value)
                  setLast_name(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="h-10 flied ">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.HEIGHT')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={height_cm}
                maxLength="3"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  setHeight_cm(value);
                }}
              />
              <div className="content-unit">{t('GLOBAL.CENTIMETER')}</div>
            </div>
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.WEIGHT')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={weight_kg}
                maxLength="3"
                onChange={(e) => {
                  setWeight_kg(e.target.value.replace(/[^0-9]/g, ''));
                }}
              />
              <div className="content-unit">{t('GLOBAL.KILOGRAM')}</div>
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.GENDER')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <div className="dropdown-container">
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={genderSwitch} data={{ id: 0, keys: [t('GLOBAL.FEMALE'), t('GLOBAL.MALE')], data: gender }} returnData={setGender} />
              </div>
            </div>
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.BIRTHDAY')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <div className="inner" onClick={handleClick}>
                {dayMonth ? dayMonth : <span style={{ color: '#999' }}>{t('GLOBAL.SELECT_DATE')}</span>}
              </div>
              {CalSwitch && (
                <div className="pos-a" style={{ zIndex: 20 }} onClick={(e) => e.stopPropagation()}>
                  <DatePicker selected={birth_date} onChange={handleChange} inline peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" maxDate={new Date()} />
                </div>
              )}

              {/* </div> */}
              {/* 接收DatePicker的選擇後日期，日期格式 EX:11/30 */}
              {/* {CalSwitch && (
                            <div className="pos-a" onClick={e => e.stopPropagation()}>
                                <DatePicker selected={birth_date} onChange={handleChange} inline peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select"/>
                            </div>
                        )} */}
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.BLOOD_TYPE')}</div>
            <div className="fx-ccc w-75 h-75 content_input font-s">
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('A');
                }}
                defaultChecked={blood_type === 'A'}
              />
              <div>A</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('B');
                }}
                defaultChecked={blood_type === 'B'}
              />
              <div>B</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('AB');
                }}
                defaultChecked={blood_type === 'AB'}
              />
              <div>AB</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('O');
                }}
                defaultChecked={blood_type === 'O'}
              />
              <div>O</div>
              <div className="fx-ccc h-75 RH-blood">
                <input
                  type="radio"
                  style={{ width: '20%' }}
                  name="radioRH"
                  onClick={() => {
                    setBlood_type_RH('-');
                  }}
                  defaultChecked={blood_type_RH === '-'}
                />
                <div>{t('GLOBAL.RH_NEGATIVE')}</div>
                <input
                  type="radio"
                  style={{ width: '20%' }}
                  name="radioRH"
                  onClick={() => {
                    setBlood_type_RH('-');
                  }}
                  defaultChecked={blood_type_RH === '+'}
                />
                <div>{t('GLOBAL.RH-POSITIVE')}</div>
              </div>
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.ADDRESS')}</div>
            <div className="fx-ccc w-75 h-75 content_input">
              <input
                type="text"
                value={address}
                onChange={(e) => {
                  setAddress(e.target.value);
                }}
              />
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeB">{t('GLOBAL.EMERGENCY_CONTACT')}</div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.NAME')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={emerg_name}
                onChange={(e) => {
                  setEmerg_name(e.target.value.replace(/^[0-9]/g, ''));
                }}
              />
            </div>
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.HOME_PHONE')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={emerg_home_phone}
                maxLength="10"
                onChange={(e) => {
                  setEmerg_home_phone(e.target.value.replace(/[^0-9]/g, ''));
                }}
              />
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.CELLPHOME_NUMBER')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                value={emerg_cell_phone}
                maxLength="10"
                onChange={(e) => {
                  setEmerg_cell_phone(e.target.value.replace(/[^0-9]/g, ''));
                }}
              />
            </div>
            <div></div>
            <div></div>
          </div>
          <div className="h-10 flied"></div>
        </div>
      </div>

      <div className="wrap-personal-btn w-100 h-10">
        <div className="h-100 r-s-container">
          <div className="h-100 flied">
            <div className="fx-ccc w-100"></div>
          </div>
        </div>
        <div className="h-100 l-s-container">
          <div className="h-100 flied">
            {/* <div className="fx-ccc w-50 btn_type" onClick={()=>{putSubmit()}}>{t('GLOBAL.CONFIRM')}</div> */}
            <div
              className="fx-ccc w-50 btn_type"
              onClick={() => {
                setPop({
                  open: true,
                  content: txt,
                  parameter: [],
                });
              }}>
              {t('GLOBAL.CONFIRM')}
            </div>
            <div className="fx-ccc w-50 btn_type" onClick={props.hide}>
              {t('GLOBAL.CANCEL')}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default REPersonal;
